const openNewsletter = document.querySelector("#newsletter-trigger a")

if (openNewsletter) {
    openNewsletter.addEventListener("click", (e) => {
        e.preventDefault()

        const newsletter = document.querySelector("#newsletter")
        newsletter.classList.add("show")
    })
}
